import styled from 'styled-components';
import factoryButton from './utils/factoryButton';
import { ButtonContainedSC } from './ButtonContained';
const ButtonFabSC = styled(ButtonContainedSC) `
  box-shadow: ${(props) => props.theme.SizeShadowButtonFloating}
    ${(props) => props.theme.ColorShadowButtonFloating};

  position: absolute;
  top: ${(props) => props.top};
  right: ${(props) => props.right};
  bottom: ${(props) => props.bottom};
  left: ${(props) => props.left};
`;
export { ButtonFabSC };
export default factoryButton(ButtonFabSC, 'fab');
//# sourceMappingURL=ButtonFab.js.map